
export const a11yKeyPressWrapper = function (onClickCallback) {
    return function (event) {
        if (event.which === 32 || event.which === 13) {
            onClickCallback(event);
            event.preventDefault();
        }
    };
};
